import React from 'react';
import './contact.css';

const Contact = () => {
  return (
    <section id="contact" className='py-2 py-md-3'>
  <div className="container-lg">
    <div className="text-center">
    
      <h2>CONTACT ME</h2>
    
    <div className="align-items-center"> 
          <div className="text-center text-md-center mt-3">
          <p className='lead'> nivedha.deepak.v@gmail.com </p>
         <p className='lead'> <a href="https://instagram.com/the.curious.developer?igshid=YmMyMTA2M2Y=" className='p text-black lead' target="_blank" rel="noreferrer">Instagram</a> </p>
         <p className='lead'> <a href="https://www.linkedin.com/in/nivedha-deepak-768961208/" className='p text-black lead' target="_blank" rel="noreferrer">LinkedIn</a> </p>
            
          </div>
          {/* <div class="col-md-5 mt-2 text-start text-md-start mx-4">
              <p className='lead text-muted'>Follow me on </p>
              <a href="https://instagram.com/the.curious.developer?igshid=YmMyMTA2M2Y=" className='mx-1 text-black'>Instagram</a> 
              <a href="www.linkedin.com/in/nivedha-deepak-768961208" target="_blank" className='text-black'>. LinkedIn</a> 
              
          </div> */}
    </div>
      <p class="text-black text-md-end text-center"> {/* Copyright <span className='text-muted copyright'>© 2022</span> */} Made with ❤️ by Nivedha Deepak</p>
      {/* <footer className='text-center text-md-end'>
        <p className='h6'><span id="copyright">&copy; 2022 Made by <a href="#home" className='p text-dark fw-bold'>The Curious Developer</a></p>
      </footer> */} 
     
    </div>
      </div>
</section>

  )
}

export default Contact